"use client";

import type { ReactNode } from "react";

type GlassPanelProps = {
  children: ReactNode;
  variant?: "soft" | "bordered";
  className?: string;
};

export function GlassPanel({ children, variant = "soft", className }: GlassPanelProps) {
  const baseClasses =
    "rounded-2xl border border-border-subtle bg-surface-glass/70 p-6 text-offwhite/80 backdrop-blur-lg shadow-soft md:p-8";
  const merged = className ? `${baseClasses} ${className}` : baseClasses;

  const content = <div className={merged}>{children}</div>;

  if (variant === "bordered") {
    return (
      <div className="rounded-2xl bg-gradient-gold p-[1px] shadow-[0_15px_55px_rgba(5,6,20,0.6)]">
        {content}
      </div>
    );
  }

  return content;
}
